import React from "react";
// import "../../css/ConnectView.css";
// import Amb from "../../components/ConnectComponent";
import "./style.css";

import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import Heading from "../../components/Heading";
import ManifestoPoint from "../../components/ManifestoPoint";
// import AmbassadorApplication from "../../components/ambassadorapplication";

// let duration = 400;

export class MemberManifesto extends React.Component {
  constructor(args) {
    super(args);
    this.state = {};
  }

  componentDidMount() {}
  render() {
    const { location } = this.props;
    return (
      <ContentPage>
        <Meta
          title="Winpe | Member Manifesto"
          description="Winpe Founding Partners have collectively identified priorities and KPIs for their joint action towards enhancing gender diversity within the investing ecosystem."
          // image={
          //   "https://winpeforum.com/assets/elements/WinPE_Connect_Page_link_image.jpg"
          // }
          location={location}
        />
        <div className="partnermanifesto">
          <ManifestoPoint />
        </div>
      </ContentPage>
    );
  }
}
MemberManifesto.propTypes = {
  location: PropTypes.object,
};

export default MemberManifesto;



// WEBPACK FOOTER //
// ./src/pages/membermanifesto/index.js